module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"purchase_button":"UPGRADE","col_plan_name":"Plan","col_plan_price":"Price","col_plan_apply":" "},"ja":{"purchase_button":"アップグレード","col_plan_name":"プラン名","col_plan_price":"プラン料金","col_plan_apply":"お申し込み"}}')
  delete Component.options._Ctor
}
